"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.useClass = useClass;
var _react = _interopRequireDefault(require("react"));
var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));
var _hoc = require("./hoc");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Helper that provides methods to easily create
// BEM style block/element/modifier classes.
function _default(Component) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  // Unwrap wrapped components
  var Wrapped = (0, _hoc.getWrappedComponent)(Component);
  var block = (0, _kebabCase["default"])("".concat(prefix).concat(Wrapped.name));
  function _getBlockClass(props, modifiers) {
    return getClassNames(block, modifiers, props.className);
  }
  function getElementClass(element) {
    for (var _len = arguments.length, modifiers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      modifiers[_key - 1] = arguments[_key];
    }
    return getClassNames("".concat(block, "__").concat(element), modifiers);
  }
  if (Wrapped.prototype instanceof _react["default"].Component) {
    Wrapped.prototype.getBlockClass = function () {
      var _this$getModifiers;
      return _getBlockClass(this.props, ((_this$getModifiers = this.getModifiers) === null || _this$getModifiers === void 0 ? void 0 : _this$getModifiers.call(this)) || []);
    };
    Wrapped.prototype.getElementClass = getElementClass;
    return Component;
  } else {
    return (0, _hoc.wrapComponent)(Component, function (props) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, _objectSpread(_objectSpread({}, props), {}, {
        getBlockClass: function getBlockClass() {
          for (var _len2 = arguments.length, modifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            modifiers[_key2] = arguments[_key2];
          }
          return _getBlockClass(props, modifiers);
        },
        getElementClass: getElementClass
      }));
    });
  }
}
function useClass(block) {
  var extra;
  var modifiers = [];
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  if (args[0] && _typeof(args[0]) === 'object') {
    extra = args[0].className;
    modifiers = args.slice(1);
  } else {
    modifiers = args;
  }
  var className = getClassNames(block, modifiers, extra);
  return {
    className: className,
    getElementClass: function getElementClass(element) {
      for (var _len4 = arguments.length, modifiers = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        modifiers[_key4 - 1] = arguments[_key4];
      }
      return getClassNames("".concat(block, "__").concat(element), modifiers);
    }
  };
}
function getClassNames(base, modifiers, extra) {
  var classes = [base].concat(_toConsumableArray(modifiers.filter(function (m) {
    return m;
  }).map(function (m) {
    return "".concat(base, "--").concat(m);
  })));
  if (extra) {
    classes.push(extra);
  }
  return classes.join(' ');
}